import PortfolioMobile from 'components/PortfolioMobile';
import Portfolio from '../../components/Portfolio/index';
import { DataMonteBravo } from '../../components/Portfolio/data';

export default function MonteBravo() {
  return (
    <>
      <div className="d-none d-lg-block">
        <Portfolio data={DataMonteBravo} />
      </div>
      <div className="d-block d-lg-none">
        <PortfolioMobile data={DataMonteBravo} />
      </div>
    </>
  );
}
